import React from 'react';
import withStyles from '@mui/styles/withStyles';


export const SessionInfoTable = withStyles({
	table: {
		width: '100%',
		fontSize: '1em'
	},
})(
	({classes, children}) => (
		<table className={[classes.table, 'SessionInfoTable'].filter(x => x).join(' ')}>
			<tbody>
			{children}
			</tbody>
		</table>
	));

export const SessionInfoTableRow = withStyles((theme) => ({
	row: {
		width: '100%',
	},
	col1: {
		verticalAlign: 'top',
		padding: `${theme.spacing(1, 1)}`,
		minWidth: 140,
		maxWidth: 400,
		flexGrow: 0,
	},
	col2: {
		padding: theme.spacing(1),
		minWidth: 200,
		flexGrow: 5,
		margin: 'auto',
	},
}))(({label, classes, children}) => (
	<tr className={classes.row}>
		<td className={classes.col1}>{label}</td>
		<td className={classes.col2}>{children}</td>
	</tr>
));